/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --background: var(--state-color-background);
  --color: var(--state-color);
  --gap: var(--nve-ref-space-xs);
  --font-size: var(--nve-ref-font-size-100);
  --icon-color: var(--color);
  --padding: 0 var(--nve-ref-size-200);
  --border: 0;
  --border-radius: var(--nve-ref-border-radius-sm);
  --font-weight: var(--nve-ref-font-weight-semibold);
  --text-transform: initial;
  --width: initial;
  --height: var(--nve-ref-size-600);
  display: inline-flex;
}

[internal-host] {
  font-weight: var(--font-weight);
  font-size: var(--font-size);
  gap: var(--gap);
  background: var(--background);
  color: var(--color);
  padding: var(--padding);
  border: var(--border);
  border-radius: var(--border-radius);
  width: var(--width);
  height: var(--height);
  text-transform: var(--text-transform);
  display: inline-flex;
  line-height: 1em;
  place-items: center;
}

slot:not([name]) {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: block;
  line-height: 1.15;
}

:host([aria-label]) slot:not([name]) {
  display: contents;
}

::slotted([nve-text]) {
  color: inherit !important;
}

::slotted(a) {
  margin: 0 !important;
  color: inherit !important;
  text-decoration: none !important;
  line-height: 0 !important;
}

nve-icon,
::slotted(nve-icon) {
  --color: var(--icon-color);
  --width: var(--nve-ref-size-300);
  --height: var(--nve-ref-size-300);
}

:host([status]) {
  --state-color-base: var(--status-color);
}

:host([container='flat']) {
  --background: var(--nve-sys-background-color);
  --border-radius: var(--nve-ref-border-radius-sm);
  --gap: var(--nve-ref-space-xs);
  --padding: 0;
  --text-transform: capitalize;
  --width: initial;
  --height: initial;
}
